/********************************************************************************
 * Copyright (c) 2020-2021 EclipseSource and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0 WITH Classpath-exception-2.0
 ********************************************************************************/

.sprotty-issue-background {
    fill: var(--glsp-issue-background);
    background-color: var(--glsp-issue-background);
}

.sprotty-issue.sprotty-error {
    fill: var(--glsp-error-foreground);
    background-color: var(--glsp-error-foreground);
}

.sprotty-issue.sprotty-warning {
    fill: var(--glsp-warning-foreground);
    background-color: var(--glsp-warning-foreground);
}

.sprotty-issue.sprotty-info {
    fill: var(--glsp-info-foreground);
    background-color: var(--glsp-info-foreground);
}
